// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_1VA","cls2":"FocusedNavView-cls2_6xG FocusedNavView-cls1_1VA"};